import {createSelector} from '@reduxjs/toolkit'

import {isEmpty} from '@shared/helpers/lang'

import {APIStatus} from '@web/core/constants'

import {RootState} from './interfaces'

export const waterfallResponseSelector = (state: RootState) => state.recommendationProduct.waterfallResponse

export const fetchDoneSelector = (state: RootState) => {
    const {apiStatus} = state.recommendationProduct
    return apiStatus === APIStatus.RESOLVED
}

export const adStatusSelector = (state: RootState) => state.recommendationProduct.adStatus

export const productOrderListSelector = createSelector(
    (state: RootState) => state.recommendationProduct.products,
    (products): Maybe<string> => {
        const refineProducts = products.filter(isProductValid).map(stringifyProduct).join('^')

        if (isEmpty(refineProducts)) {
            return null
        }

        return `productOrderList:${encodeURIComponent(refineProducts)},browserOpen:1`
    },
)

function isProductValid(product: {
    ecNvMid?: number
    orderDateTime?: string
    productOrderStatus?: string
    productPaymentAmount?: number
    productCategoryId?: string
}): product is {
    ecNvMid: number
    orderDateTime: string
    productOrderStatus: string
    productPaymentAmount: number
    productCategoryId: string
} {
    const {ecNvMid, orderDateTime, productOrderStatus, productPaymentAmount, productCategoryId} = product
    return (
        !!ecNvMid &&
        !!orderDateTime &&
        !!productOrderStatus &&
        !!productPaymentAmount &&
        productPaymentAmount > 0 &&
        !!productCategoryId
    )
}

function stringifyProduct(product: {
    ecNvMid: number
    orderDateTime: string
    productOrderStatus: string
    productPaymentAmount: number
    productCategoryId: string
}): string {
    const {ecNvMid, orderDateTime, productOrderStatus, productPaymentAmount, productCategoryId} = product
    return [
        ecNvMid,
        Math.floor(new Date(orderDateTime).getTime() / 1000),
        productOrderStatus,
        productPaymentAmount,
        productCategoryId,
    ].join('|')
}
